var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGarageCircle = function SvgGarageCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    d: "M11.746 6.52a.204.204 0 0 0-.076-.14c-.006-.003-.01-.01-.015-.014L8.113 4.075a.208.208 0 0 0-.226 0L4.345 6.366a.166.166 0 0 0-.015.015.192.192 0 0 0-.052.062.215.215 0 0 0-.024.078.166.166 0 0 0-.004.02v5a.208.208 0 0 0 .208.209h7.084a.208.208 0 0 0 .208-.208v-5a.148.148 0 0 0-.004-.021Zm-5.83 2.73h4.167v.833H5.917V9.25Zm4.376-1.667H5.5v-.416h5v.416h-.208ZM10.083 8v.833H5.917V8h4.166Zm-4.166 3.333V10.5h4.166v.833H5.917Zm4.583 0V8h.208a.208.208 0 0 0 .209-.208v-.834a.208.208 0 0 0-.209-.208H5.292a.208.208 0 0 0-.209.208v.834A.208.208 0 0 0 5.292 8H5.5v3.333h-.833V6.655L8 4.5l3.333 2.157v4.676H10.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    fillRule: "evenodd",
    d: "M8 15.57A7.57 7.57 0 1 0 8 .43a7.57 7.57 0 0 0 0 15.14ZM8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z",
    clipRule: "evenodd"
  })));
};
export default SvgGarageCircle;